(function($) {

    if ($('main').attr('data-model-type') !== 'paj/models/collaborators/collaborator') {
        return
    }

    var isEditing = $('html').attr('data-template') === 'edit'
    var isCreating = !isEditing

    var Selectors = {
        groups: {
            educationalType: '.js-group-collaborator-educationalType',
            financialIncentiveLastModified: '.js-group-collaborator-financialIncentiveLastModified',
            financialIncentiveDescription: '.js-group-collaborator-financialIncentiveDescription',
        },
        inputs: {
            types: '.js-collaborator-types:input',
            specifications: '.js-collaborator-specifications:input',
            educationalType: '.js-collaborator-educationalType:input',
            mrc: '.js-collaborator-mrc:input',
            hasFinancialIncentive: '.js-group-collaborator-hasFinancialIncentive :input',
            financialIncentiveLastModified: '.js-group-collaborator-financialIncentiveLastModified .datetimepickerinput',
            agreementStatus: '.js-collaborator-agreementStatus:input',
            isNational: '.js-collaborator-isNational',
        },
    }

    var hideEducationalType = function () {
        $(Selectors.groups.educationalType).hide()
        $(Selectors.inputs.educationalType).val('')
        $(Selectors.inputs.educationalType).prop('disabled', true)
    }

    var onChangeTypes = function () {
        var $selected = $(this)
        var selectedValues = $selected.val()

        if (selectedValues.includes('educational')) {
            $(Selectors.groups.educationalType).show()
            $(Selectors.inputs.educationalType).prop('disabled', false)
        } else {
            hideEducationalType()
        }

        $(Selectors.inputs.educationalType).selectpicker('refresh')

        checkIfIsNational()
    }

    var checkIfIsNational = function () {
        var $mrcInput = $(Selectors.inputs.mrc)
        var $typesInput = $(Selectors.inputs.types)
        var $isNationalInput = $(Selectors.inputs.isNational)

        if (!$isNationalInput.exists()) {
            return
        }

        // If the types field is absent or disabled, it means that the model
        // has been saved, and its types cannot be changed anymore.
        if (!$typesInput.exists() || $typesInput.is(':disabled')) {
            return
        }

        // Don't do anything if no MRC is selected
        var mrcValue = $mrcInput.val()
        var typeValues = $typesInput.val()
        if (mrcValue === '' || typeValues.length === 0) {
            return
        }

        Charcoal.Admin.manager().ready(() => {
            // Large urban centers are stored in the mrc selectpicker options. A bit hacky, but it works.
            var $mrcSelectPicker = $mrcInput.selectpicker()
            var mrcSelectPickerOptions = $mrcSelectPicker.data('selectpicker').options
            var largeUrbanCenters = mrcSelectPickerOptions.largeUrbanCenters

            // A collaborator may have more than one MRC
            // In that case, only check if only one MRC is selected.
            if (Array.isArray(mrcValue)) {
                if (mrcValue.length > 1) {
                    return;
                }
                mrcValue = mrcValue[0];
            }

            if (largeUrbanCenters.includes(mrcValue) && typeValues.includes('employer')) {
                var $isNationalCheckbox = $('input', $isNationalInput)
                $isNationalCheckbox.prop('checked', true)
            }
        })
    }

    var onChangeMrc = function () {
        checkIfIsNational()
    }

    var onChangeHasFinancialIncentive = function () {
        var $selected = $(this)

        if ($selected.prop('checked')) {
            // Set the date to the current date if empty
            if (!$('.datetimepicker-input', Selectors.inputs.financialIncentiveLastModified).val().length) {
                $(Selectors.inputs.financialIncentiveLastModified).datetimepicker('date', new Date());
            }

            $(Selectors.groups.financialIncentiveLastModified).show()
            $(Selectors.groups.financialIncentiveDescription).show()
        } else {
            $(Selectors.groups.financialIncentiveLastModified).hide()
            $(Selectors.groups.financialIncentiveDescription).hide()
        }
    }

    var onChangeFinancialIncentiveLastModified = function (e) {
        const warningClass = 'has-warning';
        const inputDate    = e.date !== 'undefined' ? new Date(e.date) : null;
        const oneYearAgo   = new Date().setFullYear(new Date().getFullYear() - 1);

        if (inputDate && (inputDate < oneYearAgo)) {
            e.target.classList.add(warningClass);
        } else {
            e.target.classList.remove(warningClass);
        }
    };

    /**
     * On form initialization
     */
    if (! $(Selectors.inputs.educationalType)?.val()?.length) {
        hideEducationalType()
    }

    /**
     * Triggers and listeners
     */
    if (isCreating) {
        $(document).on('change', Selectors.inputs.mrc, onChangeMrc)
        $(Selectors.inputs.mrc).trigger('change')
    }

    $(document).on('change', Selectors.inputs.types, onChangeTypes)
    $(Selectors.inputs.types).trigger('change')

    $(document).on('change', Selectors.inputs.hasFinancialIncentive, onChangeHasFinancialIncentive)
    $(Selectors.inputs.hasFinancialIncentive).trigger('change')

    $(document).on('change.datetimepicker', Selectors.inputs.financialIncentiveLastModified, onChangeFinancialIncentiveLastModified);
    //$(Selectors.inputs.financialIncentiveLastModified).on('change.datetimepicker', onChangeFinancialIncentiveLastModified);

    // Add an observer to trigger the change event on dynamically loaded forms (modals)
    var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
                $(mutation.addedNodes).each(function() {
                    // Check if any child nodes match the financial incentive selector
                    $(this).find(Selectors.inputs.hasFinancialIncentive).each(function() {
                        $(this).trigger('change');
                    });
                });
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
})(jQuery);
